<div class="overlay" [class.no-display]="!modalOpen">
  <div class="error-modal">
    <button ds-button class="close icon-exit" (click)="closeTheModal()"></button>
    <span class="heading-main">Service Temporarily Unavailable</span> Error {{ statusCode }}:
    {{ statusText }}
  </div>
</div>
